export const environment = {
	demo: true,
	production: false,
	apiUrl: 'https://demo.api.meddata.it',
	maintenance: false,
	// Vedi environment.ts per il significato del flag.
	profiling: true
};
